// Shared address types that can be used by both frontend and backend

export type Address = {
  // Preferred single-line address (Stripe/Shopify style). Optional during the
  // street/number → line1/line2 transition (ADDR-001..006); promoted to required
  // in ADDR-006 once all writers and data are migrated.
  line1?: string;
  line2?: string; // Apartment, suite, floor, etc.
  // Legacy split fields — being phased out. Read via getAddressLine1 helper.
  street?: string;
  number?: string; // Building/house number
  city: string;
  zip: string;
  state?: string; // Optional - for countries that require it
  country: Country; // Must be one of the allowed countries
};

export interface ShopAddress extends Address {
  // Shop-specific address extensions can be added here if needed
}

export const COUNTRIES = ['GB', 'DE', 'US', 'RU'] as const;

export type Country = (typeof COUNTRIES)[number];

// Countries offered in the address/branch country pickers. US is intentionally
// excluded from selection (geocoding has no US coverage yet) but stays in
// COUNTRIES so existing US addresses remain valid and `isValidCountry('US')`
// keeps returning true. Re-add 'US' here once US geocoding is supported.
export const SELECTABLE_COUNTRIES = COUNTRIES.filter(
  (country) => country !== 'US',
) as readonly Country[];

export { isValidCountry } from '../validation/address';
